import { Dialog } from "@mui/material";
import React from "react";
import PrimaryButton from "../button/PrimaryButton";
import SecondaryButton from "../button/SecondaryButton";
import TextField from "@mui/material/TextField";
import { useNavigate } from "react-router-dom";
import { SearchNexId } from "../../services/Register";
import PrimaryGreenButton from "../button/PrimaryGreenButton";
import SecondaryGreenButton from "../button/SecondaryGreenButton";
import { useLiff } from 'react-liff';

export default function CheckMemberGreenPopup(props) {
    const { onClose, selectedValue, open } = props;
    const [memberCode, setMemberCode] = React.useState(null);
    const [phoneNumber, setPhoneNumber] = React.useState(null);
    const [errorMemberCode, setErrorMemberCode] = React.useState(false);
    const [errorPhoneNumberLength, setErrorPhoneNumberLength] = React.useState(false);
    const navigate = useNavigate();

    const { liff } = useLiff();
    const lineId = liff.getDecodedIDToken().sub;

    const handleClose = () => {
        onClose(selectedValue);
    };

    const checkMember = () => {
        console.log(memberCode)
        if (memberCode) {
            getSearchRegister();
        }
    };

    async function getSearchRegister() {
        try {
            const { data } = await SearchNexId({ data: { "nexId": memberCode, species: 2, lineId: lineId, "phoneNumber": phoneNumber } })
            if (+data['resultCode'] === 20000) {
                navigate('/confirm-success-cat')
            } else {
                setErrorMemberCode(true)
            }
        } catch (error) {
            setErrorMemberCode(true)
            console.log('getSearchRegister error', error)
        }
    }

    const handleListItemClick = (value) => {
        onClose(value);
    };

    return (
        <Dialog onClose={handleClose} open={open}>
            <div id="addcat-page" className="pb-[36px] pt-[24px] px-[23px] rounded-[4px]">
                {errorMemberCode ? <>
                    <p className="text-red text-[24px] text-center">
                        ไม่พบข้อมูลดังกล่าวในระบบ
                    </p>
                    <p className="text-red text-[18px] text-center">
                        ไม่พบข้อมูลดังกล่าว กรุณาระบุใหม่อีกครั้ง หรือกด “ยกเลิก” เพื่อสมัครบริการใหม่
                    </p>
                </> : <>
                    <p className="text-green text-[24px] text-center">
                        คุณเป็นสมาชิก One And Done อยู่แล้วหรือไม่
                    </p>
                    <p className="text-[18px] text-center">
                        เพื่อความปลอดภัยอีกขั้น กรุณายืนยันตัวตนผ่านเบอร์โทรศัพท์ และเลขสมาชิก 
                        <span className="font-bold text-[22px]">One And Done Code</span>  ที่ลงทะเบียนไว้
                    </p>
                </>}


                {/* <div className="h-input"> */}
                <TextField
                    className="w-full text-[20px]"
                    label="ระบุหมายเลขโทรศัพท์"
                    required
                    variant="standard"
                    error={errorPhoneNumberLength}
                    helperText="กรุณากรอกเบอร์โทรศัพท์อย่างน้อย 10 หลัก"
                    value={phoneNumber}
                    inputProps={{ maxLength: 10 }}
                    onChange={(event, newValue) => {
                        if (newValue !== null) {
                            setPhoneNumber(event.target.value);
                            if (event.target.value.length < 10) {
                                setErrorPhoneNumberLength(true)
                            } else {
                                setErrorPhoneNumberLength(false)
                            }

                        }
                    }}
                />
                <TextField
                    className="w-full text-[20px]"
                    label="ระบุเลขสมาชิก One And Done Code"
                    required
                    variant="standard"
                    value={memberCode}
                    onChange={(event, newValue) => {
                        if (newValue !== null) {
                            setMemberCode(event.target.value);
                        }
                    }}
                />
                {/* </div> */}
                <div className="flex itesm-center gap-[13px] justify-center mt-[24px]">
                    <PrimaryGreenButton
                        disabled={!memberCode || errorPhoneNumberLength}
                        variant="outlined"
                        className="w-[50%]"
                        onClick={checkMember}
                    >
                        ตกลง
                    </PrimaryGreenButton>
                    <SecondaryGreenButton
                        variant="outlined"
                        className="w-[50%]"
                        onClick={handleClose}
                    >
                        ยกเลิก
                    </SecondaryGreenButton>
                </div>
            </div>
        </Dialog>
    );
}